import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import FleetManagementApiService from './FleetManagementApiService'
import { GET_SAVE_ADMIN_TASK_VALUE, GET_SAVE_AFE_ADMIN_TASK_VALUE, GET_SAVE_ASSET_ADMIN_TASK_VALUE } from '../../Store/FleetManagement/FleetAdminTask/AdminTaskType'
import { setSaveAdminTaskvalue } from 'Store/FleetManagement/FleetAdminTask/AdminTaskAction';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';

function* saveFleetAdminTask(req: any): any {
    try {
        yield put(globalLoaderText("Saving values...."));
        let payloadData : IPayload= {
            apiType : apiType.FleetManagement,
            endpoint : `fleet/item/task`, 
            apiMethod :  apiMethod.PUT,
            payload : req?.adminTaskSaveValue
            
        }
        const response = yield call(
            FleetManagementApiService.post,API_URL.PostWebApp,payloadData
        );
        response.orderRequestId = req?.adminTaskSaveValue?.orderRequestId
        if (response) {
            yield put(setSaveAdminTaskvalue(response))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(globalLoaderText(""));
    }
}

function* saveAssetFleetAdminTask(req: any): any {    
    try {
     

        yield put(globalLoaderText("Saving values...."));
        let payloadData: IPayload = {
            apiType : apiType.FleetManagement,
            endpoint : `fleet/asset/item/task`,
            apiMethod : apiMethod.PUT,
            payload : req?.adminAssetTaskSaveValue

        }
        const response = yield call(
            FleetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        if (response) {
            yield put(setSaveAdminTaskvalue(response))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(globalLoaderText(""));
    }
}

function* saveAfeFleetAdminTask(req: any): any {    
    try {
     

        yield put(globalLoaderText("Saving values...."));
        let payloadData: IPayload = {
            apiType : apiType.FleetManagement,
            endpoint : `fleet/afe/item/task`,
            apiMethod : apiMethod.PUT,
            payload : req?.adminAfeTaskSaveValue

        }
        const response = yield call(
            FleetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        if (response) {
            yield put(setSaveAdminTaskvalue(response))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(globalLoaderText(""));
    }
}

function* watchGetSaveAdminTask() {
    yield takeEvery(GET_SAVE_ADMIN_TASK_VALUE, saveFleetAdminTask)
    yield takeEvery(GET_SAVE_ASSET_ADMIN_TASK_VALUE, saveAssetFleetAdminTask)
    yield takeEvery(GET_SAVE_AFE_ADMIN_TASK_VALUE, saveAfeFleetAdminTask)
}

export default function* combinedSaga() {
    yield all([
        watchGetSaveAdminTask()
    ])
}
